<!--
 * @Description: 券统计
 * @Author: yuxin
 * @Date: 2025-06-25 16:00:41
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-07-01 09:38:41
 * @FilePath: \mgr_web\src\views\contentCenter\newMall\getGouponsStatistics\index.vue
-->

<template>
  <div class="getGouponsStatistics-container">
    <header>
      <el-input
        placeholder="活动名称"
        suffix-icon="el-icon-search"
        size="mini"
        @blur="searchFn"
        @clear="searchFn"
        v-model="formData.name"
        clearable
        style="width: 180px; margin-right: 10px"
      >
      </el-input>
      <el-button-group>
        <el-button size="mini">
          发送时间
        </el-button>
        <el-date-picker
          v-model="formData.searchSelectTime"
          size="mini"
          type="daterange"
          value-format="yyyy-MM-dd "
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="timeChange"
          :clearable="false"
          :editable="false"
          style="width: 240px; margin-right: 10px"
          :default-time="['00:00:00', '23:59:59']"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-button-group>
      <!-- <el-select
        v-model="formData.type"
        placeholder="请选择"
        size="mini"
        @change="typeChange"
      >
        <el-option
          v-for="item in activityOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select> -->
    </header>
    <main>
      <el-table
        ref="tableData"
        :data="tableData"
        style="width: 100%"
        height="calc(100vh - 290px)"
        @sort-change="sortChange"
        :default-sort="{ prop: 'sendTotal', order: 'descending' }"
      >
        <el-table-column prop="name" label="活动名称" width="180">
        </el-table-column>
        <el-table-column
          prop="shareNumber"
          label="发送次数"
          sortable="custom"
          width="180"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="shareOpenNumber"
          label="点击次数"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="rate"
          label="打开率"
          :sort-method="sortMethod"
        >
          <!-- <template slot-scope="scope">
            {{ scope.row.clickRate }}%
          </template> -->
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="registerNumber"
          label="注册人数"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="couponNumber"
          label="领券人数"
          :sort-method="sortMethod"
        >
          <!-- <template slot-scope="scope">
            {{ scope.row.salesRate }}
          </template>-->
        </el-table-column>
      </el-table>
    </main>
    <footer>
      <Pagination
        v-bind:childMsg="pageparm"
        :pageSizes="pageSizes"
        @callBack="callBack"
      ></Pagination>
    </footer>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { getCouponDetailApi } from "@/api/contentCenter/Statistics";
export default {
  name: "activityStatistics",
  data() {
    return {
      /** 表单数据 */
      formData: {
        /** 条件筛选名称 */
        name: "",

        /** 开始时间 */
        /** 转为时间戳 */
        startTime: dayjs(
          dayjs()
            .subtract(30, "days")
            .format("YYYY-MM-DD 00:00:00")
        ).valueOf(), //开始时间,
        /** 结束时间 */
        /** 转为时间戳 */
        endTime: dayjs(
          dayjs()
            .subtract(1, "days")
            .format("YYYY-MM-DD 23:59:59")
        ).valueOf(), //结束时间,
        /** 前端定义，用于存储时间 */
        searchSelectTime: [
          dayjs()
            .subtract(30, "days")
            .format("YYYY-MM-DD 00:00:00"),
          dayjs()
            .subtract(1, "days")
            .format("YYYY-MM-DD 23:59:59"),
        ],
        /** 活动类型 0:限时特惠 1:砍价 2:抽奖 3:拼团 6.领券活动 全部活动时不传 */
        type: "",
        /** 排序字段 */
        sort: "",
        /** 是否升序 */
        asc: false,
        /** 当前页码 */
        page: 1,
        /** 每页条数 */
        size: 10,
      },
      /** 禁用今天和未来日期的逻辑 */
      pickerOptions: {
        disabledDate(time) {
          /** 获取今天0点的时间戳（去除时间部分） */
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          /** 禁用今天及未来日期（time.getTime() >= today.getTime()） */
          return time.getTime() >= today.getTime();
        },
      },
      /** 筛选的活动集合 */
      //   activityOptions: [
      //     { label: "全部活动", value: "" },
      //     { label: "拼团活动", value: 3 },
      //     { label: "砍价活动", value: 1 },
      //     { label: "限时特惠", value: 0 },
      //     { label: "抽奖活动", value: 2 },
      //   ],

      /** 表格数据 */
      tableData: [],

      /** 分页参数 */
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },

      /** 分页选择参数 */
      pageSizes: [10, 20, 50, 100, 200, 500],
    };
  },
  methods: {
    /** 获取列表数据 */
    async getDataList() {
      const res = await getCouponDetailApi(
        this.formData,
        localStorage.getItem("Authorization")
      );
      if (res && res.error.code == 200 && res.data) {
        console.log("res++++", res);
        this.tableData = res.data.records;
        this.pageparm.total = res.data.total ? Number(res.data.total) : 0;
      }
    },

    /**  分页回调 */
    callBack(parm) {
      console.log("分页器XXXX", parm);
      this.formData.page = parm.currentPage;
      this.formData.size = parm.pageSize;
      this.getDataList();
    },

    /** 时间变动触发 */
    timeChange(val) {
      if (val) {
        /** 转为时间戳 */
        this.formData.startTime = dayjs(
          dayjs(val[0]).format("YYYY-MM-DD 00:00:00")
        ).valueOf();
        this.formData.endTime = dayjs(
          dayjs(val[1]).format("YYYY-MM-DD 23:59:59")
        ).valueOf();
      }
      this.getDataList();
    },

    /** 排序变化 */
    sortChange(column, prop, order) {
      console.log("column", column);
      if (!column.order) {
        this.formData.sort = "";
        this.formData.asc = false;
      } else {
        this.formData.sort = column.prop;
        this.formData.asc = column.order === "ascending";
      }
      console.log("this.formData", this.formData);
      this.getDataList();
      //   if (val.order === "ascending") {
      //     this.formData.sortRule = "asc";
      //   } else if (val.order === "descending") {
      //     this.formData.sortRule = "desc";
      //   }
      //   this.formData.sortField = val.prop;
      //   this.getDataList();
      //   console.log(
      //     "排序变化",
      //     this.formData,
      //     dayjs()
      //       .subtract(29, "days")
      //       .format("YYYY-MM-DD hh:mm:ss")
      //   );
    },

    /** 搜索触发 */
    searchFn() {
      this.getDataList();
    },

    /** 类型变触发 */
    typeChange() {
      this.getDataList();
    },

    // 排序
    sortMethod() {},
  },

  /** 生命周期 */
  created() {
    /** 获取列表数据 */
    this.getDataList();
  },
};
</script>

<style scoped lang="scss">
.getGouponsStatistics-container {
  /deep/.el-table {
    overflow: visible !important;
    .has-gutter {
      font-weight: 700;
    }
  }
}
</style>
